<template>
  <div class="map-legend">
    <p class="map-legend__uom" v-if="uom">{{ uom }}</p>
    <p class="map-legend__dateUpdate" v-if="date" v-html="date">
    </p>
  </div>
</template>

<script>
export default {
  name: "MapLegend",
  props: {
    uom: {
      type: String,
      required: false,
    },
    date: {
      type: String,
      required: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.map-legend {
  position: absolute;
  top: 1.2vh;
  left: 4.9vw;
  z-index: 10;
  @include dida-S;

  &__dateUpdate {
    font-style: italic;
  }
}
</style>
